import { MeterOptions } from '../types';

/**
 *
 * it filters the meter options based on the selected options
 */
export const filterSelectedOptions = (
  meterOptions: MeterOptions[],
  selectedOptions: string[],
): MeterOptions[] => meterOptions.filter(({ name }) => selectedOptions.includes(name));
